import { useBulkActionsState } from './useBulkActionsState';
export const useBulkActionsIsLoading = () => {
  const state = useBulkActionsState();
  return Object.values(state.loading).some(Boolean);
};